import type { ChatTheme } from '../theme';
const warned = new Set<string>();
function warnOnce(name: string, message: string) { if (!warned.has(name)) { warned.add(name); console.warn(`[osvi-chat] ${message}`); } }
export function oneOf<T extends string>(value: string | null | undefined, allowed: readonly T[]): T | undefined { return value != null && (allowed as readonly string[]).includes(value) ? value as T : undefined; }
export function parseRadius(value: string | null | undefined): ChatTheme['radius'] | undefined {
 if (value == null) return undefined;
 return oneOf(value, ['none', 'sm', 'md', 'lg', 'full'] as const) ?? (/^\d{1,2}(?:px)?$/.test(value) ? Number(value.replace(/px$/, '')) : undefined);
}
export function safeBaseUrl(value: string | null | undefined): string | undefined {
 if (!value) return undefined;
 try { const u = new URL(value); if (!u.username && !u.password && (u.protocol === 'https:' || u.protocol === 'http:' && ['localhost', '127.0.0.1'].includes(u.hostname))) return value.replace(/\/+$/, ''); } catch { /* ignored */ }
 warnOnce('base-url', 'ignored an invalid base-url (https required, http only for localhost)'); return undefined;
}
export function safeAvatar(value: string | null | undefined): string | undefined {
 if (!value) return undefined;
 if (/^data:image\/(png|jpeg|gif|webp);base64,[a-z0-9+/]+={0,2}$/i.test(value)) return value;
 try { const u = new URL(value); if (u.protocol === 'https:' && !u.username && !u.password) return value; } catch { /* ignored */ }
 return undefined;
}
export function parseJsonAttr(name: string, value: string | null | undefined): Record<string, unknown> | undefined {
 if (!value) return undefined;
 try { const parsed: unknown = JSON.parse(value); if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed as Record<string, unknown>; } catch { /* warn below */ }
 warnOnce(name, `ignored invalid JSON in the ${name} attribute`); return undefined;
}
